module.exports = ".modal-body {\n  padding: 0 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/2fa/modals/manage-user-2fa-modal/manage-user-2fa-modal.scss
// module id = ./web/modern/components/2fa/modals/manage-user-2fa-modal/manage-user-2fa-modal.scss
// module chunks = 0